/**
 * Whether this person sees the way into Prospecting: the sidebar rows, the
 * folded rail's glyph, the command palette's entries and the Settings tab.
 *
 * An admin always does (an owner there). Anybody else does once GET /me says
 * they have a seat, and the question is only asked for them, so an admin's
 * column draws its rows without waiting on the prospects service. The answer
 * is the same cached query the pages' access gate reads, so asking it here
 * costs one request per app load at most.
 */
import { useQuery } from '@tanstack/react-query'
import { useSession } from '../../../lib/session'
import { prospectingApi, prospectingQueryKeys } from './api'
import { accessFrom, showsProspecting } from './access-model'
import type { Me } from './types'

export function useProspectingSeat(): boolean {
  const { isAdmin, session } = useSession()
  const query = useQuery({
    queryKey: prospectingQueryKeys.me(),
    queryFn: ({ signal }) => prospectingApi<Me>('/me', { signal }),
    enabled: session !== undefined && !isAdmin,
    staleTime: 5 * 60_000,
    retry: false,
  })
  return showsProspecting(isAdmin, accessFrom(query))
}
